import { render, staticRenderFns } from "./FreemiumEndDialog.vue?vue&type=template&id=5858b345&scoped=true"
import script from "./FreemiumEndDialog.vue?vue&type=script&lang=js"
export * from "./FreemiumEndDialog.vue?vue&type=script&lang=js"
import style0 from "./FreemiumEndDialog.vue?vue&type=style&index=0&id=5858b345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858b345",
  null
  
)

export default component.exports